module.exports = __webpack_public_path__ + "assets/beschikbaarheid2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/beschikbaarheid2.jpg
// module id = 143
// module chunks = 0